import type { MobileRoute } from '@lumapps/mobile-webview/message-emit/redirect/types';
import { createPageRoute, AppId } from '@lumapps/router';

const feedRoute: MobileRoute = {
    ...createPageRoute({ slug: 'feed', appId: AppId.frontOffice }),
    // When in webview mode for the mobile, this makes the mobile app redirect to the native personal feed
    mobilePageDescriptor: { type: 'personal-feed' },
};

const feed = (): MobileRoute => ({
    ...feedRoute,
    params: {},
});

export { feed, feedRoute };
